export { default } from "./DetailsModal";
